import { render, staticRenderFns } from "./x-upload.vue?vue&type=template&id=71c3c3ae"
import script from "./x-upload.vue?vue&type=script&lang=js"
export * from "./x-upload.vue?vue&type=script&lang=js"
import style0 from "./x-upload.vue?vue&type=style&index=0&id=71c3c3ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports